import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

export const DeleteConfirmation = withReactContent(Swal);

export const PasswordConfirmation = withReactContent(Swal);

export const ExpirationConfirmation = withReactContent(Swal);

export const ConfirmLead = withReactContent(Swal);

export const ConfirmIaDataCollect = withReactContent(Swal);

export const AssignClaimConfirmation = withReactContent(Swal);

export const TranfertClaimConfirmation = withReactContent(Swal);
